<template>
  <div>
    <beautiful-chat
      :disableUserListToggle="true"
      :placeholder="'Digite uma pergunta...'"
      :participants="participants"
      :titleImageUrl="titleImageUrl"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :newMessagesCount="newMessagesCount"
      :isOpen="isChatOpen"
      :close="closeChat"
      :icons="icons"
      :open="openChat"
      :showEmoji="false"
      :showFile="false"
      :showTypingIndicator="showTypingIndicator"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :messageStyling="messageStyling"
      @onType="handleOnType"
      @edit="editMessage"
    >
      <template v-slot:header>
        <h3>Precisa de orientação?</h3>
      </template>
    </beautiful-chat>
  </div>
</template>

<script>
import Vue from 'vue'

import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'

export default {
  name: 'app',
  data() {
    return {
      icons: {
        open: {
          img: OpenIcon,
          name: 'default'
        },
        close: {
          img: CloseIcon,
          name: 'default'
        },
        file: {
          img: FileIcon,
          name: 'default'
        },
        closeSvg: {
          img: CloseIconSvg,
          name: 'default'
        }
      },
      participants: [
        {
          id: 'tataBot',
          imageUrl: 'https://i.imgur.com/BiCQFsc.png'
        }
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: '',
      messageList: [
        {
          type: 'text',
          author: `tataBot`,
          data: {
            text: `Olá! Meu nome é Tata. Me faça uma pergunta que farei o máximo para te responder`
          }
        },
        {
          author: 'tataBot',
          type: 'text',
          data: {
            text: 'Selecione uma das opções para melhor te ajudar'
          },
          suggestions: [
            // 'Saber mais sobre: Contábil',
            // 'Saber mais sobre: Tributário Federal',
            // 'Saber mais sobre: Vigência',
            'Saber mais sobre: Trabalhista',
            'Sobre mais sobre: Cursos'
          ]
        }
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4e8cff'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
    }
  },
  methods: {
    sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen
          ? this.newMessagesCount
          : this.newMessagesCount + 1
        this.onMessageWasSent({
          author: 'support',
          type: 'text',
          data: { text }
        })
      }
    },
    onMessageWasSent(message) {
      // called when the user sends a message
      this.messageList = [...this.messageList, message]
      this.getMessageBot(message)
    },
    getMessageBot(message) {
      this.showTypingIndicator = '...'
      Vue.axios
        .post('https://tata-backend-prod.herokuapp.com/send', {
          message: message.data.text
        })
        .then(async response => {
          this.showTypingIndicator = ''

          function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms))
          }

          if (response.data.length) {
            // console.log(response.data) // eslint-disable-line no-console
            for (let index = 0; index < response.data.length; index++) {
              const message = response.data[index]

              if (index >= 1) {
                this.showTypingIndicator = '...'
                await sleep(3000)
                this.showTypingIndicator = ''
              }

              if (message.text) {
                this.messageList = [
                  ...this.messageList,
                  {
                    author: 'tataBot',
                    type: 'text',
                    data: { text: message.text.text[0] }
                  }
                ]
              } else if (message.quickReplies) {
                this.messageList = [
                  ...this.messageList,
                  {
                    author: 'tataBot',
                    type: 'text',
                    data: {
                      text: 'Selecione uma das opções para melhor te ajudar'
                    },
                    suggestions: message.quickReplies.quickReplies
                  }
                ]
              }
            }
          }
        })
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    handleScrollToTop() {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType() {
      // console.log('Emit typing event')
    },
    editMessage(message) {
      const m = this.messageList.find(m => m.id === message.id)
      m.isEdited = true
      m.data.text = message.data.text
    }
  }
}
</script>
